import React from 'react'

import { Navigate } from 'react-router-dom'

import Snackbar from '../../shared/components/Snackbar/Snackbar.functions'
import {
  isAdminLoggedIn,
  isAuthenticated,
  isLogisticsPartnerLoggedIn,
  setAdminLoginStatus,
  setLogisticsPartnerLoginStatus
} from '../../shared/functions/Auth/auth.functions'
import { UserRole } from '../../shared/functions/UserRole/userRoleManagement.types'
import { getUserRole, removeUserRole } from '../../shared/functions/UserRole/userRoleManagment.functions'
import { Route as HourrierRoute } from '../router.types'
import routes from '../routes.dictionary'

interface RedirectHandlerProps {
  route: HourrierRoute
}

const RedirectHandler: React.FC<RedirectHandlerProps> = ({ route }) => {
  const isUserAuthenticated = isAuthenticated()
  const userRole = getUserRole()
  const isAdminDashboardRoute = route.path === routes.adminDashboard.path
  const isLogisticsDashboardRoute = route.path === routes.logisticsPartnerDashboard.path
  let defaultPathToNavigate: string | { pathname: string; search: string; hash: string }

  switch (userRole) {
    case UserRole.shopper:
      defaultPathToNavigate = `/${routes.shop.path}`
      break

    case UserRole.sender:
      defaultPathToNavigate = `/${routes.send.path}`
      break

    default:
      defaultPathToNavigate = { pathname: '/', search: '', hash: '' }
  }

  // Admin users should only access admin dashboard
  if (isAdminLoggedIn() && !isAdminDashboardRoute) {
    return <Navigate to={`/${routes.adminDashboard.path}`} replace />
  }

  // Non-admin users should not access admin dashboard
  if (!isAdminLoggedIn() && isAdminDashboardRoute) {
    return <Navigate to={defaultPathToNavigate} />
  }

  // Logistics partners should only access logistics dashboard
  if (isLogisticsPartnerLoggedIn() && !isLogisticsDashboardRoute) {
    return <Navigate to={`/${routes.logisticsPartnerDashboard.path}`} replace />
  }

  // Non-logistics users should not access logistics dashboard
  if (!isLogisticsPartnerLoggedIn() && isLogisticsDashboardRoute) {
    return <Navigate to={defaultPathToNavigate} replace />
  }

  // Check authentication requirement
  if (route.isAuthenticationRequired && !isUserAuthenticated) {
    Snackbar.show({
      message: 'Please login to continue.',
      severity: 'error'
    })

    if (isAdminLoggedIn()) {
      setAdminLoginStatus(false)
    }

    if (isLogisticsPartnerLoggedIn()) {
      setLogisticsPartnerLoginStatus(false)
    }

    removeUserRole()

    return <Navigate to={`/${routes.login.path}`} />
  } else {
    return route.component ? React.createElement(route.component) : null
  }
}

export default RedirectHandler
